import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { TaskRole, TaskRoleCreate } from '../task-roles.types';
import { AccountService } from 'app/core';
import { Account } from 'app/core/models';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import * as CustomValidator from '../../../../shared/directives/custom-validators.directive';
import { Store, Actions, ofActionSuccessful } from '@ngxs/store';
import { TaskRolesActions } from '../state/actions';
import { TaskRolesState } from '../state/state';

@Component({
  selector: 'task-roles-add',
  templateUrl: './task-roles-add.component.html',
  styleUrls: ['./task-roles-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskRolesAddComponent extends OnDestroyMixin implements OnInit {
  public taskRoleForm: UntypedFormGroup;
  public isLoading: boolean = false;

  private get account(): Account {
    return this.accountService.getCurrentAccount();
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public readonly matDialogRef: MatDialogRef<TaskRolesAddComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly accountService: AccountService,
    private readonly snackBar: MatSnackBar,
    private readonly store: Store,
    private readonly actions$: Actions,
  ) {
    super();
  }

  ngOnInit(): void {
    this.buildForm();

    this.actions$.pipe(ofActionSuccessful(TaskRolesActions.Create), untilComponentDestroyed(this)).subscribe(() => {
      const taskRole = this.store.selectSnapshot(TaskRolesState.getNew);
      if (taskRole.errors && taskRole.errors.length > 0) {
        this.snackBar.open(taskRole.errors[0], null, {
          duration: 3000,
          panelClass: 'error-snackbar',
        });
      } else {
        this.discard(taskRole);
      }
    });
  }

  public get isSaveBtnDisabled(): boolean {
    return this.isLoading || this.taskRoleForm.pristine || this.taskRoleForm.invalid;
  }

  private buildForm(): void {
    this.taskRoleForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3), CustomValidator.noWhiteValidator]],
    });
  }

  public discard(taskRole?: TaskRole): void {
    this.matDialogRef.close(taskRole);
  }

  public save(): void {
    const data: TaskRoleCreate = {
      applicable_type: this.data.relatedToType,
      name: this.taskRoleForm.value.name,
      accountId: this.account.id,
    };
    this.store.dispatch(new TaskRolesActions.Create(data));
  }

  // Function attached to debounce-click directive to flag the button's disable state.
  public isDebounceLoading(isLoading: boolean): boolean {
    return (this.isLoading = isLoading);
  }
}
